class AbstractDojoRequestRecord {
    constructor(method, url) {
        if (['GET', 'POST', 'PUT', 'DELETE'].includes(method) === false) {
            throw new Error('Unknown or missing HTTP method');
        }
        if (!url) {
            throw new Error('Missing request url');
        }
        this.method = method;
        this.url = url;
    }
}

module.exports = AbstractDojoRequestRecord;
